import { Star } from "lucide-react";

export function Marquee({ items }) {
  const list = items && items.length ? items : ["365 CELLULAR ENERGY"];
  const row = [...list, ...list, ...list];
  return (
    <div className="relative border-y border-emerald-500/15 bg-[#0D130F] py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display text-lg sm:text-xl font-bold tracking-[0.18em] text-gray-200 px-6 whitespace-nowrap">{item}</span>
                <Star className="w-4 h-4 text-yellow-600 fill-yellow-600 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
